import {Component, Inject, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';
import { RestoreStatus } from 'src/app/models/restores/restore-status';
import { FormUtilService } from 'src/app/services/util/form-util.service';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

  title: string = translate('DIALOG.CONFIRMATION');
  message: string;
  scheduleName: string;
  note: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  cancelButtonText: string = translate('DIALOG.CANCEL');
  optionSelection: any;
  confirmationTitle: string;
  selectedOption: string;
  noteWithBg: boolean;
  noteTextColor: boolean;
  ticketIdField: boolean;
  noteSizing: boolean;
  ticketForm: FormGroup;
  secondaryRegion: boolean;
  secondaryMsg: boolean;
  restoreList: any;
  warning: boolean;
  summary1: string;
  summary2: string;
  infraWarning: boolean;
  page: string;
  imageName: string;
  updatedOn: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder,
    public matdialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  ngOnInit(): void {
    this.title = this.data?.title || this.title;
    this.message = this.data?.message;
    this.secondaryRegion = this.data?.secondaryRegionWarn;
    this.secondaryMsg = this.data?.secondaryMsg;
    this.scheduleName = this.data?.scheduleName ? this.data?.scheduleName + ' ?' : '';
    this.note = this.data.note;
    this.noteWithBg = this.data.noteWithBg;
    this.noteTextColor = this.data.noteTextColor;
    this.ticketIdField = this.data.ticketIdField;
    this.noteSizing = this.data.noteSizing;
    this.restoreList = this.data.restoreList;
    this.warning = this.data.warning;
    this.summary1 = this.data.summary1;
    this.summary2 = this.data.summary2;
    this.infraWarning = this.data.infraWarning;
    this.page = this.data.page;
    this.imageName = this.data.imageName || '';
    this.updatedOn = this.data.updatedOn || '';
    if (this.ticketIdField) {
      const formConfig: any = {
        ticketNumber: ['', [Validators.required, Validators.pattern(/^ITSM-[a-zA-Z0-9].{1}|^CEPR-[a-zA-Z0-9].{1}/)]],
      };
      this.ticketForm = this.formBuilder.group(formConfig);
    }
    if (this.data?.optionSelection) {
      this.optionSelection = this.data.optionSelection;
      this.selectOptions(this.optionSelection[0]);
    }

    if (this.data?.confirmationTitle) {
      this.confirmationTitle = this.data.confirmationTitle;
    }

    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
    this.cancelButtonText = this.data.cancelButtonText || this.cancelButtonText;
  }

  selectOptions(option): void {
    if(this.optionSelection) {
      for (const items of this.optionSelection) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    option.selected = !option.selected;
    this.selectedOption = option;
  }

  dialogClose(): void {
  let option = null;
  if (this.ticketIdField) {
    if (!FormUtilService.validateForm(this.ticketForm)) {
      return;
    } else {
      option = {
        ticketNumber: this.ticketForm.value.ticketNumber
      };
    }
  } else if (this.optionSelection?.length) {
    option = this.optionSelection.find(opt => opt.selected);
  } else {
      option = true;
    }
  this.matdialogRef.close(option);
}

ticketIdChange(event): void {
  if (this.page === 'sizingApply' || !this.restoreList) {
    return;
  }
  const data = this.restoreList.filter(item => item.status !== RestoreStatus.PREPARATION_FAILED && item.status !== RestoreStatus.PROMOTION_FAILED);
  if (data.find(item => item.ticketNumber === this.ticketForm.get('ticketNumber')?.value)) {
    this.ticketForm.get('ticketNumber').setErrors({duplicateTicket: true});
  } else {
    this.ticketForm.get('ticketNumber').clearValidators();
    this.ticketForm.updateValueAndValidity();
  }
}
}
